// Whimsical loading words used by the generic ThinkingFooter (logs view)
// and as the fallback pool for the WhatsNext PreFlightPanel before the
// run status narrows down to a more contextual list. Each word is meant
// to be readable mid-typing-animation, so keep them ASCII-leaning and
// short enough to finish typing comfortably inside the rotate interval.

export const GENERIC_THINKING_WORDS: readonly string[] = [
  "Bidouillating",
  "Mijoticating",
  "Gribouillating",
  "Pinaillating",
  "Magouillating",
  "Tortillating",
  "Patouillating",
  "Bricolating",
  "Embrouillating",
  "Triturating",
  "Iterionning",
  "Schmilblicking",
  "Mouliningette",
  "Voilàssembling",
  "Rafistolating",
  "Trifouilling",
  "Fignoling",
  "Gambergifying",
  "Bafouillating",
  "Tambouilling",
  "Bouillonnating",
  "Ronronnating",
  "Manigancing",
  "Chamboulificating",
  "Démerdouilling",
  "Chuchotating",
  "Vasouilling",
  "Tintouinifying",
  "Baguettomancing",
  "Saucissonnaging",
  "Cocoricoding",
  "Bidouillonnant",
  "Zinzinifying",
  "Patapouflicating",
  "Cogitruffing",
  "Ratiocinating",
  "Ponderificating",
  "Reflectomancing",
  "Schemarbling",
  "Iterificating",
  "Branchifying",
  "Routerising",
  "Judgifying",
  "Diagrammifying",
  "Excogitating",
  "Heuristicating",
  "Algorithmancing",
  "Conjecturizing",
  "Recursificating",
  "Postulificating",
  "Stratagemizing",
  "Promptomancing",
  "Tokenificating",
  "Schemificating",
  "Heuristomancing",
  "Hypothesifying",
  "Synthesimorphing",
  "Permutologizing",
];
